export const getSessionItem = key => {
  if (typeof window === 'undefined') return null // SSR safety

  const value = sessionStorage.getItem(key)
  return value !== null && value !== '' ? value : null
}
